import useGetMemberBenefit from "#/components/carrot-plans/hooks/useGetMemberBenefit"
import { CarrotRxPharmacyType } from "#/lib/carrot-api/types/Benefit"

export const useIsFreedomFertility = () => {
  const { data: benefit, isLoading, isError } = useGetMemberBenefit()

  return {
    isFreedomFertility: benefit?.carrotRx.fertilityPharmacy === CarrotRxPharmacyType.FREEDOM_FERTILITY,
    isLoading,
    isError
  }
}
